/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type UpdateChatMessageTemplateInput = {
  body: string;
  guid: string | number;
  label: string;
  selections: Array<string>;
};

export type SettingsPageGetMessageTemplateByIdQueryVariables = Exact<{
  guid: string | number;
}>;


export type SettingsPageGetMessageTemplateByIdQuery = { chatMessageTemplate: { guid: string, label: string, body: string, selections: Array<string> } };

export type SettingsPageUpdateChatMessageTemplateMutationVariables = Exact<{
  input: Types.UpdateChatMessageTemplateInput;
}>;


export type SettingsPageUpdateChatMessageTemplateMutation = { updateChatMessageTemplate: { guid: string, label: string, body: string, selections: Array<string> } };


export const SettingsPageGetMessageTemplateByIdDocument = gql`
    query SettingsPageGetMessageTemplateById($guid: ID!) {
  chatMessageTemplate(guid: $guid) {
    guid
    label
    body
    selections
  }
}
    `;

/**
 * __useSettingsPageGetMessageTemplateByIdQuery__
 *
 * To run a query within a Vue component, call `useSettingsPageGetMessageTemplateByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useSettingsPageGetMessageTemplateByIdQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSettingsPageGetMessageTemplateByIdQuery({
 *   guid: // value for 'guid'
 * });
 */
export function useSettingsPageGetMessageTemplateByIdQuery(variables: SettingsPageGetMessageTemplateByIdQueryVariables | VueCompositionApi.Ref<SettingsPageGetMessageTemplateByIdQueryVariables> | ReactiveFunction<SettingsPageGetMessageTemplateByIdQueryVariables>, options: VueApolloComposable.UseQueryOptions<SettingsPageGetMessageTemplateByIdQuery, SettingsPageGetMessageTemplateByIdQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SettingsPageGetMessageTemplateByIdQuery, SettingsPageGetMessageTemplateByIdQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SettingsPageGetMessageTemplateByIdQuery, SettingsPageGetMessageTemplateByIdQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SettingsPageGetMessageTemplateByIdQuery, SettingsPageGetMessageTemplateByIdQueryVariables>(SettingsPageGetMessageTemplateByIdDocument, variables, options);
}
export function useSettingsPageGetMessageTemplateByIdLazyQuery(variables?: SettingsPageGetMessageTemplateByIdQueryVariables | VueCompositionApi.Ref<SettingsPageGetMessageTemplateByIdQueryVariables> | ReactiveFunction<SettingsPageGetMessageTemplateByIdQueryVariables>, options: VueApolloComposable.UseQueryOptions<SettingsPageGetMessageTemplateByIdQuery, SettingsPageGetMessageTemplateByIdQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SettingsPageGetMessageTemplateByIdQuery, SettingsPageGetMessageTemplateByIdQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SettingsPageGetMessageTemplateByIdQuery, SettingsPageGetMessageTemplateByIdQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<SettingsPageGetMessageTemplateByIdQuery, SettingsPageGetMessageTemplateByIdQueryVariables>(SettingsPageGetMessageTemplateByIdDocument, variables, options);
}
export type SettingsPageGetMessageTemplateByIdQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SettingsPageGetMessageTemplateByIdQuery, SettingsPageGetMessageTemplateByIdQueryVariables>;
export const SettingsPageUpdateChatMessageTemplateDocument = gql`
    mutation SettingsPageUpdateChatMessageTemplate($input: UpdateChatMessageTemplateInput!) {
  updateChatMessageTemplate(input: $input) {
    guid
    label
    body
    selections
  }
}
    `;

/**
 * __useSettingsPageUpdateChatMessageTemplateMutation__
 *
 * To run a mutation, you first call `useSettingsPageUpdateChatMessageTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSettingsPageUpdateChatMessageTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSettingsPageUpdateChatMessageTemplateMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useSettingsPageUpdateChatMessageTemplateMutation(options: VueApolloComposable.UseMutationOptions<SettingsPageUpdateChatMessageTemplateMutation, SettingsPageUpdateChatMessageTemplateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SettingsPageUpdateChatMessageTemplateMutation, SettingsPageUpdateChatMessageTemplateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SettingsPageUpdateChatMessageTemplateMutation, SettingsPageUpdateChatMessageTemplateMutationVariables>(SettingsPageUpdateChatMessageTemplateDocument, options);
}
export type SettingsPageUpdateChatMessageTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SettingsPageUpdateChatMessageTemplateMutation, SettingsPageUpdateChatMessageTemplateMutationVariables>;